<template>
    <div>
        <form v-if="wizard.operation == 'edit'" @submit.prevent="getCustomer" id="get_sh_by_code">
            <div class="container p-3 pt-5 my-4 border in-border-header" style="text-align: right">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('pos.get_signature_holder_by_code') }}
                    </div>
                    <kt-row>
                        <kt-col lg="5" md="6" xs="12">
                            <kt-form-group>

                                <kt-form-label for="national_code">
                                    {{ $t('label.national_code') }}
                                </kt-form-label>
                                <kt-form-control
                                        style="text-align: left;text-decoration: solid"
                                        id="national_code"
                                        name="national_code"
                                        v-model="inquiry_form.national_code"
                                        type="number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="3"
                                xs="5">
                            <kt-form-action style="margin-top: 10px" class="mt-4">
                                <kt-button
                                        class="m-2"
                                        size="md"
                                        variant="success"
                                        type="submit"
                                        v-bind:wide="true"
                                        id="submit_btn1"
                                >
                                    {{ $t('pos.btn_inquiry') }}
                                </kt-button>
                            </kt-form-action>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>

        <form v-if="show_customer_detail" id="signature_holder">
            <div class="container p-3 pt-5 my-4 border in-border-header" style="text-align: right">
                <div class="section-header">
                    {{ $t('pos.signature_holder') }}
                </div>
                <kt-row>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="national_code">
                                {{ $t('pos.national_code') }}
                            </kt-form-label>
                            <span style="color: red">{{ ' *' }}</span>
                            <kt-form-control
                                    dir="ltr"
                                    id="national_code"
                                    name="national_code"
                                    :disabled="!$can('manage','pos')"
                                    v-model="form_data.customer_detail.signature_holder.sh_national_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="!is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_number">
                                {{ $t('label.birth_crtfct_number') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="birth_crtfct_number"
                                    name="birth_crtfct_number"
                                    v-model="form_data.customer_detail.signature_holder.sh_birth_crtfct_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="signatory_birth_crtfct_serial">
                                {{ $t('label.birth_crtfct_serial') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="signatory_birth_crtfct_serial"
                                    name="signatory_birth_crtfct_serial"
                                    v-model="form_data.customer_detail.signature_holder.sh_birth_crtfct_serial"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_series_number">
                                {{ $t('label.birth_crtfct_series_number') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="birth_crtfct_series_number"
                                    name="birth_crtfct_series_number"
                                    v-model="form_data.customer_detail.signature_holder.sh_birth_crtfct_series_number"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_series_letter">
                                {{ $t('label.birth_crtfct_series_letter') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="birth_crtfct_series_letter"
                                    name="birth_crtfct_series_letter"
                                    v-model="form_data.customer_detail.signature_holder.sh_birth_crtfct_series_letter"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-bind:key="birthCrtfctSeriesLetter.key"
                                        v-for="birthCrtfctSeriesLetter in birthCrtfctSeriesLetters"
                                        :value="birthCrtfctSeriesLetter.key"
                                >
                                    {{ birthCrtfctSeriesLetter.value }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_date">
                                {{ $t('label.birth_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="birth_date"
                                    name="birth_date"
                                    v-model="form_data.customer_detail.signature_holder.sh_birth_date" type="date"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="gender_id">
                                {{ $t('label.gender') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-select
                                    id="gender_id"
                                    name="gender_id"
                                    v-model="form_data.customer_detail.signature_holder.sh_gender_id"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-for="(item,index) in constants.gender" v-bind:key="index" :value="index">
                                    {{ item }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="first_name_fa">
                                {{ $t('label.first_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="first_name_fa"
                                    name="first_name_fa"
                                    v-model="form_data.customer_detail.signature_holder.sh_first_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="last_name_fa">
                                {{ $t('label.last_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="last_name_fa"
                                    name="last_name_fa"
                                    v-model="form_data.customer_detail.signature_holder.sh_last_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="first_name_en">
                                {{ $t('label.first_name_en') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="first_name_en"
                                    name="first_name_en"
                                    v-model="form_data.customer_detail.signature_holder.sh_first_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="last_name_en">
                                {{ $t('label.last_name_en') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="last_name_en"
                                    name="last_name_en"
                                    v-model="form_data.customer_detail.signature_holder.sh_last_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="father_name_fa">
                                {{ $t('label.father_name_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="father_name_fa"
                                    name="father_name_fa"
                                    v-model="form_data.customer_detail.signature_holder.sh_father_name_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="father_name_en">
                                {{ $t('label.father_name_en') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="father_name_en"
                                    name="father_name_en"
                                    v-model="form_data.customer_detail.signature_holder.sh_father_name_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="mobile">
                                {{ $t('pos.mobile') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="mobile"
                                    dir="ltr"
                                    name="mobile"
                                    v-model="form_data.customer_detail.signature_holder.sh_mobile"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="country">
                                {{ $t('label.country_flag') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="country"
                                    name="country"
                                    v-model="form_data.customer_detail.signature_holder.sh_country"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-for="country in constants.country"
                                        v-bind:key="country.CountryCode"
                                        :value="country.CountryCode">
                                    {{ country.CountryName }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="foreign_pervasive_code">
                                {{ $t('pos.foreign_pervasive_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="foreign_pervasive_code"
                                    name="foreign_pervasive_code"
                                    v-model="form_data.customer_detail.signature_holder.sh_foreign_pervasive_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="passport_number">
                                {{ $t('pos.passport_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    id="passport_number"
                                    name="passport_number"
                                    type="number"
                                    dir="ltr"
                                    v-model="form_data.customer_detail.signature_holder.sh_passport_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="is_foreign" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="passport_expire_date">
                                {{ $t('pos.passport_credit_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="passport_expire_date"
                                    name="passport_expire_date"
                                    v-model="form_data.customer_detail.signature_holder.sh_passport_expire_date"
                                    type="date"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="12" md="12" xs="12">
                        <kt-form-group>

                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                       id="is_foreign_"
                                       name="is_foreign_nationals"
                                       v-model="is_foreign"
                                >
                                <label class="custom-control-label"
                                       for="is_foreign_">{{ $t('pos.is_foreign') }}</label>
                            </div>
                        </kt-form-group>

                    </kt-col>
                </kt-row>
            </div>
        </form>
    </div>
</template>

<script>
import {KTApp} from '@/plugins/core/app';
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {mapGetters} from "vuex";
import {customerType} from '@/constants/posNovin'
import {posService} from '@/common/api.service'
import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter'
import {posStatuses, managerCanEditDocuments, visitorCanEditDocuments} from '@/constants/PosStatus';
import Inputmask from "inputmask";


export default {
    data() {
        return {
            can_edit: false,
            is_foreign: false,
            customerType,
            birthCrtfctSeriesLetters,
            posStatuses,
            managerCanEditDocuments,
            visitorCanEditDocuments,
            inquiry_form: {
                customer_type_id: customerType.REAL
            },
            show_customer_detail: false,
        }
    },
    watch: {
        is_foreign: {
            handler(newValue, oldValue) {
                this.form_data.customer_detail.signature_holder.sh_is_foreign = newValue
            }
        }
    },
    props: {
        form_data: {
            type: Object
        },
        wizard: {
            type: Object
        },
    },
    methods: {
        getCustomer() {
            let form = $('#get_sh_by_code')
            let btn = $('#submit_btn1')
            this.show_detail = false
            form.validate({
                lang: 'fa',
                rules: {
                    national_code: {
                        required: true,
                        digits: true,
                        minlength: 10,
                        maxlength: 10
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            this.is_foreign = false
            KTApp.progress(btn)
            this.inquiry_form.psp = 'PASARGAD'
            this.show_customer_detail = false
            posService.getCustomerByCode(this.inquiry_form).then(response => {
                if (response.data.data) {
                    this.form_data.customer_detail.signature_holder = this.setCustomerDataCallback(response.data.data)
                    this.show_customer_detail = true
                    this.afterDispatch()

                    if (!this.$can('manage', 'pos')) {
                        this.$store.commit('pos/canChange', false)
                    } else {
                        this.$store.commit('pos/canChange', true)
                    }
                    this.showMsg(form, 'success', response.data.message)
                } else {
                    this.$store.commit('pos/canChange', true)
                    this.is_foreign = false
                    this.form_data.signature_holder.sh_customer_type_id = this.inquiry_form.customer_type_id
                    this.form_data.signature_holder.sh_national_code = this.inquiry_form.national_code
                    this.showMsg(form, 'danger', response.data.message)
                }
                this.show_customer_detail = true
                this.afterDispatch()
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        setCustomerDataCallback(data) {
            let signature_holder = {
                sh_birth_crtfct_number: data.birth_crtfct_number,
                sh_birth_date: data.birth_date,
                sh_gender_id: data.gender_id,
                sh_mobile: data.mobile,
                sh_last_name_fa: data.last_name_fa,
                sh_last_name_en: data.last_name_en,
                sh_national_code: data.national_code,
                sh_passport_expire_date: data.passport_expire_date,
                sh_passport_number: data.passport_number,
                sh_birth_crtfct_serial: data.birth_crtfct_serial,
                sh_birth_crtfct_series_number: data.birth_crtfct_series_number,
                sh_birth_crtfct_series_letter: data.birth_crtfct_series_letter,
                sh_first_name_fa: data.first_name_fa,
                sh_father_name_en: data.father_name_en,
                sh_country: data.country_code,
                sh_foreign_pervasive_code: data.foreign_pervasive_code
            }
            this.is_foreign = data.is_foreign_nationals;

            return signature_holder;
        },
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 2000)
            setTimeout(
                    document.getElementById('mobile') && Inputmask('09999999999')
                            .mask(document.getElementById('mobile')), 500)
        },
    },
    mounted() {
        this.afterDispatch()
        if (this.form_data.customer_detail.signature_holder) this.show_customer_detail = true;

        if ((this.$can('manage', 'pos') && managerCanEditDocuments.includes(this.form_data.status)) ||
                (this.$can('update', 'pos') && visitorCanEditDocuments.includes(this.form_data.status)) ||
                (this.wizard.operation === 'create')) {
            this.can_edit = true;
        }
    },
    computed: {
        ...mapGetters('pos', [
            'constants', 'can_change', 'psp'
        ])
    }
}
</script>

<style>
</style>